<template>
  <v-container class="py-10">
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
        md="8"
        lg="6"
      >
        <v-card elevation="2">
          <v-card-title>
            Mi cuenta
          </v-card-title>

          <v-card-text>
            <v-skeleton-loader
              v-if="cargandoPerfil"
              type="article"
            />

            <v-alert
              v-else-if="mensajeError"
              type="error"
              text
            >
              {{ mensajeError }}
            </v-alert>

            <div v-else-if="cliente">
              <h2 class="mb-5">
                Hola, {{ cliente.nombre }}
              </h2>

              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ nombreCompleto }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      Nombre y apellido
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ cliente.email }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      Correo electrónico
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="cliente.whatsapp">
                  <v-list-item-icon>
                    <v-icon>mdi-whatsapp</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ cliente.whatsapp }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      WhatsApp
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-btn
              text
              color="primary"
              :to="{ name: 'pedidos' }"
            >
              Mis pedidos
            </v-btn>

            <v-spacer />

            <v-btn
              color="error"
              text
              :loading="cerrandoSesion"
              @click="cerrarSesion"
            >
              Cerrar sesión
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClienteAuthService from "../service/ClienteAuthService";

export default {
  name: "ClientePerfilView",

  data() {
    return {
      cliente: null,
      cargandoPerfil: true,
      cerrandoSesion: false,
      mensajeError: "",
    };
  },

  computed: {
    nombreCompleto() {
      if (!this.cliente) {
        return "";
      }

      return [
        this.cliente.nombre,
        this.cliente.apellido,
      ]
        .filter(Boolean)
        .join(" ");
    },
  },

  mounted() {
    this.cargarPerfil();
  },

  methods: {
    async cargarPerfil() {
      this.cargandoPerfil = true;
      this.mensajeError = "";

      try {
        const respuesta =
          await ClienteAuthService.obtenerPerfil();

        this.cliente = respuesta.data.cliente;

        localStorage.setItem(
          "cliente_data",
          JSON.stringify(this.cliente)
        );
      } catch (error) {
        localStorage.removeItem("cliente_token");
        localStorage.removeItem("cliente_data");

        this.$router.replace({
          name: "cliente-login",
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } finally {
        this.cargandoPerfil = false;
      }
    },

    async cerrarSesion() {
      this.cerrandoSesion = true;

      try {
        await ClienteAuthService.logout();
      } catch (error) {
        /*
         * Aunque el token ya haya vencido,
         * limpiamos igualmente la sesión local.
         */
      } finally {
        localStorage.removeItem("cliente_token");
        localStorage.removeItem("cliente_data");

        this.cerrandoSesion = false;

        this.$router.replace({
          name: "cliente-login",
        });
      }
    },
  },
};
</script>